import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/liff/`;

const checkIdentity = async (accessToken, shopId) => {
    return await axios.post(API_URL + 'check-identity', { accessToken, shopId });
};

const getAwaitingAction = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'awaiting-action', { accessToken, shopId });
    return res.data;
};

const getOrderSummaryByOrderIds = async (accessToken, shopId, orderIds, orderIdsByGroup = null) => {
    const res = await axios.post(API_URL + 'order-summary', {
      accessToken,
      shopId,
      orderIds,
      ...(orderIdsByGroup && { orderIdsByGroup }),
    });
    return res.data;
};

const getAddresses = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'addresses', { accessToken, shopId });
    return res.data;
};

const getShipDateInfo = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'ship-date-info', { accessToken, shopId });
    return res.data;
};

const submitSelectAction = async (payload) => {
    const res = await axios.post(API_URL + 'select-action', payload);
    return res.data;
};

const createPaymentLink = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'create-payment-link', {
        accessToken,
        shopId,
    });
    return res.data;
};

const createQrCharge = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'create-qr-charge', {
        accessToken,
        shopId,
    });
    return res.data;
};

const getPaymentSummary = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'payment-summary', { accessToken, shopId });
    return res.data;
};

const createGroup2PaymentLink = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'create-group2-payment-link', { accessToken, shopId });
    return res.data;
};

const getGroup2BankInfo = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'group2-bank-info', { accessToken, shopId });
    return res.data;
};

const verifyReceipt = async (accessToken, shopId, qrString) => {
    const res = await axios.post(API_URL + 'verify-receipt', { accessToken, shopId, qrString });
    return res.data;
};

const submitGroup2Receipt = async (accessToken, shopId, qrString, receiptFile, options = {}) => {
    const { manualCheck = false } = options;
    const formData = new FormData();
    formData.append('accessToken', accessToken);
    formData.append('shopId', shopId);
    if (manualCheck) {
        formData.append('manualCheck', 'true');
    } else {
        formData.append('qrString', qrString);
    }
    formData.append('receipt', receiptFile);
    const res = await axios.post(API_URL + 'submit-group2-receipt', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
};

const getPastRemarks = async (accessToken, shopId) => {
    const res = await axios.post(API_URL + 'past-remarks', { accessToken, shopId });
    return res.data?.remarks || [];
};

const LiffService = {
    checkIdentity,
    getAwaitingAction,
    getOrderSummaryByOrderIds,
    getAddresses,
    getShipDateInfo,
    submitSelectAction,
    getPaymentSummary,
    createPaymentLink,
    createQrCharge,
    createGroup2PaymentLink,
    getGroup2BankInfo,
    verifyReceipt,
    submitGroup2Receipt,
    getPastRemarks,
};

export default LiffService;
